import React, { useState, useEffect, useContext } from "react";
import {
  Grid,
  Tab,
  Tabs,
  Box,
  useMediaQuery,
  Button,
  TextField,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Card,
  CardContent,
  CircularProgress,
  Backdrop,
  Fade,
} from "@mui/material";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import BedOutlinedIcon from "@mui/icons-material/BedOutlined";
import WineBarIcon from "@mui/icons-material/WineBar";
import HikingRoundedIcon from "@mui/icons-material/HikingRounded";
import Guests from "./guests/Guests";
import RoomTypeRatePlan from "./roomType/RoomTypeRatePlan";
import Summary from "./summary/Summary";
import SummaryPruebaCarrito from "./summary/SummaryPruebaCarrito";
import Products from "../pages/Products";
import Activities from "../pages/Activities";
import Banner from "./banner/Banner";
import Calendar2 from "./calendar/Calendar2";
import PromotionalCode from "./promotionalCode/PromotionalCode";
import Cookies from "js-cookie";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import dayjs from "dayjs";
import "dayjs/locale/es";
import { rutLosHeroes, obtenerDatosHotel, datosPax, consultarAfiliadoAebu } from "../services/motorService";
import CheckoutContext from "./contexts/CheckoutContext";
import RoomTypeRatePlanContext from "./contexts/RoomTypeRatePlanContext";
import RoomsContext from "./contexts/RoomsContext";

/**
 * NOTA: Este componente lo dejo tal cual lo tenías por si lo usabas en algún momento,
 * pero para el requerimiento nuevo el overlay se maneja desde MainComponent.
 */
const RedirectingHotel = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const params = new URLSearchParams(location.search);
  const targetHotcod = params.get("targetHotcod");
  const hotelName = params.get("hotelName") || "";

  const BASE_URL = "/MotorReservasAdmintour";



  useEffect(() => {
    if (!targetHotcod) return;

    /*const targetUrl = `${BASE_URL}/disponibilidad/habitaciones?hotcod=${encodeURIComponent(
      targetHotcod
    )}`;
*/
    const qs = new URLSearchParams(location.search);

    qs.set("hotcod", targetHotcod);

    const targetUrl =
      `${BASE_URL}/disponibilidad/habitaciones?${qs.toString()}`;
    // ✅ abre en otra pestaña
    window.open(targetUrl, "_blank", "noopener,noreferrer");

    // opcional: después de unos segundos volver a la pantalla de habitaciones del hotel actual
    const t = setTimeout(() => {
      const currentParams = new URLSearchParams(location.search);
      const hotcodActual = currentParams.get("hotcod");

      navigate(`${BASE_URL}/disponibilidad/habitaciones?hotcod=${hotcodActual || ""}`);
    }, 2500);

    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      sx={{
        minHeight: "55vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
      }}
    >
      <Card
        sx={{
          width: "100%",
          maxWidth: 720,
          borderRadius: 3,
          boxShadow: "0px 10px 30px rgba(0,0,0,0.10)",
        }}
      >
        <CardContent sx={{ p: { xs: 3, md: 4 } }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <CircularProgress size={28} />
            <Typography variant="h6">
              Se lo está redirigiendo al motor de reservas
              {hotelName ? ` del hotel "${hotelName}"` : ""}.
            </Typography>
          </Box>

          <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
            Realice su búsqueda para las fechas que desea visitar.
          </Typography>

          <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 2 }}>
            Si no se abrió una nueva pestaña, revise si su navegador está bloqueando popups.
          </Typography>

          <Box sx={{ mt: 3, display: "flex", gap: 1, justifyContent: "flex-end" }}>
            <Button
              variant="outlined"
              onClick={() => navigate(-1)}
              sx={{ borderRadius: 999 }}
            >
              Volver
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

// ✅ Antes esto era un flag fijo para todo el motor. Ahora lo que un hotel
// muestra (solo Habitaciones, solo Actividades, o ambas) sale del campo
// "MotorHotelTipo" que trae obtenerDatosHotel: "H" = solo hotel, "A" = solo
// actividades, "T" = ambas. Buscamos el campo sin importar mayúsculas/
// minúsculas porque no tenemos 100% confirmado el casing exacto que
// devuelve la API.
const getCampoCaseInsensitive = (obj, nombre) => {
  if (!obj || typeof obj !== "object") return undefined;
  const key = Object.keys(obj).find(
    (k) => k.toLowerCase() === nombre.toLowerCase()
  );
  return key ? obj[key] : undefined;
};

// Si el campo viene vacío, o la API todavía ni siquiera lo tiene en la
// respuesta (hotel no migrado / falló la consulta), se asume "H" -solo
// Habitaciones-, que es el comportamiento más conservador.
const normalizarMotorHotelTipo = (valorCrudo) => {
  const tipo = String(valorCrudo || "").trim().toUpperCase();
  return tipo === "A" || tipo === "T" ? tipo : "H";
};

// ✅ Hoteles que exigen documento OBLIGATORIO antes de buscar disponibilidad
// (mismo comportamiento que ya tenía el hotel 27): bloquea la búsqueda si no
// se cargó, y muestra el diálogo explicativo al entrar. Los hoteles de AEBU
// (30 y 31) siguen exactamente este mismo criterio, solo cambia CONTRA QUÉ
// API se valida el documento (ver handleBuscarHabitaciones más abajo).
const HOTELES_DOCUMENTO_OBLIGATORIO = ["27", "30", "31"];
const HOTELES_AEBU = ["30", "31"];

const MainComponent = () => {
  const BASE_URL = "/MotorReservasAdmintour";
  //const BASE_URL = '/QAMotorReservasAdmintour'
  const { setRutCliente, setLecturaRut } = useContext(CheckoutContext);
  const [value, setValue] = useState(0);
  const navigate = useNavigate();
  const location = useLocation(); // Hook para obtener la ruta actual
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  // ✅ Mismo picker que usa Calendar2, para que Actividades se vea igual que Habitaciones.
  const ActivityDatePickerComponent = isMobile ? MobileDatePicker : DesktopDatePicker;
  const [showLecturaRut, setShowLecturaRut] = useState(false);
  const [rut, setRut] = useState("");
  const [error, setError] = useState(null);
  const [rutData, setRutData] = useState(null);
  const [searchTrigger, setSearchTrigger] = useState(false);
  const params = new URLSearchParams(location.search);
  const hotcodParam = params.get("hotcod");
  const hotCod = hotcodParam ?? Cookies.get("hotCod") ?? null;
  const [openDocDialog27, setOpenDocDialog27] = useState(false);
  const { selectedDetails, setSelectedDetails } = useContext(RoomTypeRatePlanContext);
  const { rooms } = useContext(RoomsContext);

  // ✅ "H" por defecto (solo Habitaciones) hasta que sepamos el MotorHotelTipo
  // real del hotel: si el campo viene vacío o la API ni siquiera lo trae, se
  // comporta como si el hotel solo manejara Habitaciones.
  const [motorHotelTipo, setMotorHotelTipo] = useState("H");
  const mostrarHabitaciones = motorHotelTipo !== "A";
  const mostrarActividades = motorHotelTipo !== "H";
  const ambasDisponibles = mostrarHabitaciones && mostrarActividades;

  // ✅ Tabs que efectivamente se renderizan, en orden. Antes el código asumía
  // a fuego que "Habitaciones" era índice 0 y "Actividades" índice 1; ahora
  // que Habitaciones también se puede ocultar (hoteles "A"), el índice de
  // cada uno depende de qué tabs haya.
  const tabItems = [
    mostrarHabitaciones ? { key: "habitaciones" } : null,
    mostrarActividades ? { key: "actividades" } : null,
  ].filter(Boolean);

  // ✅ NUEVO: la búsqueda de habitaciones y la de actividades son independientes entre sí.
  // Cada una tiene su propio formulario y su propio estado de "ya busqué esto", así se puede
  // buscar una, la otra, o ambas, sin que una dependa ni reemplace a la otra.
  const [showRoomResults, setShowRoomResults] = useState(false);
  const [showActivityResults, setShowActivityResults] = useState(false);

  // ✅ NUEVO: qué formulario está "abierto" para completar (todavía sin buscar).
  // null = pantalla de selección (elegí Habitación o Actividad primero).
  // 'habitacion' | 'actividad' = ese formulario está visible.
  const [activeForm, setActiveForm] = useState(null);

  // ✅ NUEVO: datos de búsqueda de actividades (a diferencia de habitaciones, es 1 sola
  // fecha -no un período- y se pide cantidad de adultos/menores, no "huéspedes").
  // Por defecto arranca en el día de hoy.
  const [activityDate, setActivityDate] = useState(() => dayjs().format("YYYY-MM-DD"));
  const [activityAdults, setActivityAdults] = useState(2);
  const [activityChildren, setActivityChildren] = useState(0);
  const [activityError, setActivityError] = useState(null);

  // ✅ OVERLAY "redirigiendo..."
  const [redirectOverlayOpen, setRedirectOverlayOpen] = useState(false);
  const [redirectOverlayHotelName, setRedirectOverlayHotelName] = useState("");

  const ymdToUtcDate = (ymd) => {
    if (!ymd) return null;
    const [y, m, d] = ymd.split("-").map(Number);
    if (!y || !m || !d) return null;
    return new Date(Date.UTC(y, m - 1, d));
  };

  const buildUrl = (path) => {
    const qs = new URLSearchParams(location.search);
    qs.set("hotcod", hotCod);

    return `${BASE_URL}${path}?${qs.toString()}`;
  };

  // ✅ Resumen de la búsqueda de habitaciones ya realizada (fechas + huéspedes), para
  // mostrar en la barra compacta una vez que se buscó.
  const formatSelectedRange = () => {
    const s = selectedDetails?.startDate;
    const e = selectedDetails?.endDate;
    if (!s || !e) return "";
    try {
      const df = new Intl.DateTimeFormat("es-UY", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
      return `${df.format(new Date(s))} - ${df.format(new Date(e))}`;
    } catch {
      return "";
    }
  };

  // ✅ Resumen de la búsqueda de actividades (1 sola fecha).
  const formatActivityDate = () => {
    if (!activityDate) return "";
    try {
      const df = new Intl.DateTimeFormat("es-UY", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        timeZone: "UTC", // ✅ FIX: ymdToUtcDate arma la fecha en UTC medianoche; sin fijar
        // la zona acá, Intl.DateTimeFormat la mostraba en horario local (Chile, UTC-4) y
        // restaba 4 horas, corriendo la fecha mostrada un día para atrás (13 -> 12).
      });
      return df.format(ymdToUtcDate(activityDate) || new Date(activityDate));
    } catch {
      return activityDate;
    }
  };

  const guestSummaryLabel = React.useMemo(() => {
    const roomsCount = rooms?.length || 0;
    const guestsCount = (rooms || []).reduce(
      (acc, r) => acc + (r?.adultsCount || 0) + (r?.childrenCount || 0),
      0
    );
    return `${roomsCount} hab(s), ${guestsCount} pax`;
  }, [rooms]);

  const activitySummaryLabel = React.useMemo(() => {
    return `${activityAdults} adulto(s), ${activityChildren} menor(es)`;
  }, [activityAdults, activityChildren]);

  useEffect(() => {
    // Función para verificar si el hotCod está en el rango
    const isHotCodInRange = () => {
      console.log("Codigo de hotel:", hotCod);
      // ✅ Se agregan 30 y 31 (hoteles de AEBU): también piden documento para
      // buscar tarifa preferencial, igual que 6-10 (LosHeroes), 21 y 27.
      return ["6", "7", "8", "9", "10", "21", "27", "30", "31"].includes(String(hotCod));
    };
    console.log("Lectura rut", isHotCodInRange());
    // Actualiza el estado basado en la verificación
    setShowLecturaRut(isHotCodInRange());
    setLecturaRut(isHotCodInRange());
    // ✅ Documento obligatorio (bloquea la búsqueda si falta) y diálogo
    // explicativo al entrar: antes solo hotel 27, ahora también AEBU (30, 31).
    if (HOTELES_DOCUMENTO_OBLIGATORIO.includes(String(hotCod))) {
      setOpenDocDialog27(true);
    }
  }, []); // Ejecuta la verificación una sola vez al montar el componente

  // ✅ MotorHotelTipo: define si este hotel maneja solo Habitaciones (H),
  // solo Actividades (A), o ambas (T). Si el campo viene vacío, si el hotel
  // ni siquiera lo tiene cargado en Admintour, o si falla la consulta, se
  // trata como "H" (solo Habitaciones) -mismo default con el que arrancó el
  // estado-.
  useEffect(() => {
    if (!hotCod) return;
    let cancelado = false;

    (async () => {
      try {
        const data = await obtenerDatosHotel(hotCod);
        if (cancelado) return;
        const valorCrudo = getCampoCaseInsensitive(data, "motorhoteltipo");
        setMotorHotelTipo(normalizarMotorHotelTipo(valorCrudo));
      } catch (e) {
        console.error(
          "No se pudo obtener MotorHotelTipo, se muestran solo Habitaciones por defecto:",
          e
        );
        if (!cancelado) setMotorHotelTipo("H");
      }
    })();

    return () => {
      cancelado = true;
    };
  }, [hotCod]);

  // ✅ Si el hotel solo maneja una de las dos opciones (H o A), no tiene
  // sentido mostrar la pantalla de selección: arrancamos directo en esa
  // opción, como si ya se hubiera elegido. Si maneja ambas (T), no tocamos
  // activeForm acá (puede seguir en null = pantalla de selección, o en lo
  // que ya haya elegido el usuario).
  useEffect(() => {
    if (mostrarActividades && !mostrarHabitaciones) {
      setActiveForm("actividad");
    } else if (mostrarHabitaciones && !mostrarActividades) {
      setActiveForm("habitacion");
    }
  }, [mostrarHabitaciones, mostrarActividades]);

  // ✅ Mantiene el Tab seleccionado sincronizado con la URL actual (por ej. al entrar
  // directo a /disponibilidad/actividades por link, o al navegar con el botón "atrás").
  useEffect(() => {
    const enActividades =
      mostrarActividades &&
      location.pathname.startsWith(`${BASE_URL}/disponibilidad/actividades`);

    const key = enActividades ? "actividades" : "habitaciones";
    const idx = tabItems.findIndex((t) => t.key === key);
    setValue(idx >= 0 ? idx : 0);

    if (enActividades) {
      // ✅ Si se entra directo por link a /actividades, ya viene la intención
      // explícita en la URL: no tiene sentido pedirle que "elija" de nuevo.
      setActiveForm("actividad");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, mostrarHabitaciones, mostrarActividades]);

  // ✅ Si Actividades está oculto para este hotel (H) y alguien entra por
  // link directo a /disponibilidad/actividades, lo mandamos a Habitaciones
  // -y viceversa para hoteles que solo manejan Actividades (A)-.
  useEffect(() => {
    if (
      !mostrarActividades &&
      location.pathname.startsWith(`${BASE_URL}/disponibilidad/actividades`)
    ) {
      navigate(buildUrl("/disponibilidad/habitaciones"), { replace: true });
    } else if (
      !mostrarHabitaciones &&
      location.pathname.startsWith(`${BASE_URL}/disponibilidad/habitaciones`)
    ) {
      navigate(buildUrl("/disponibilidad/actividades"), { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, mostrarHabitaciones, mostrarActividades]);

  // (Esto lo dejaste para setear fechas por QS; lo mantengo tal cual, aplica a habitaciones)
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const desdeQS = params.get("desde");
    const hastaQS = params.get("hasta");

    if (!desdeQS || !hastaQS) return;
    // ✅ Esto es un deep link de búsqueda de HABITACIONES por fecha: si el
    // hotel es "A" (solo actividades) no tiene sentido forzar el flujo de
    // habitaciones.
    if (!mostrarHabitaciones) return;

    const start = ymdToUtcDate(desdeQS);
    const end = ymdToUtcDate(hastaQS);

    if (!start || !end) return;

    setSelectedDetails((prev) => ({
      ...(prev || {}),
      startDate: start,
      endDate: end,
    }));

    setSearchTrigger((prev) => !prev);
    // Si llegó un link directo con fechas ya definidas, vamos directo a resultados de habitaciones.
    setActiveForm("habitacion");
    setShowRoomResults(true);
  }, [location.search, mostrarHabitaciones]);

  // ✅ NUEVO: Detectar flag para mostrar overlay sobre el motor del hotel destino
  useEffect(() => {
    const p = new URLSearchParams(location.search);
    const flag = p.get("showRedirectOverlay");
    const hn = p.get("hotelName") || "";

    if (flag === "1") {
      setRedirectOverlayHotelName(hn);
      setRedirectOverlayOpen(true);

      // limpiar parámetros para que no se repita al refrescar
      p.delete("showRedirectOverlay");
      p.delete("hotelName");

      const newQs = p.toString();
      const newUrl = `${location.pathname}${newQs ? `?${newQs}` : ""}`;
      window.history.replaceState({}, "", newUrl);

      // autocierre (opcional)
      //const t = setTimeout(() => setRedirectOverlayOpen(false), 2500);
      //return () => clearTimeout(t);
    }
  }, [location.pathname, location.search]);

  // ✅ Punto de entrada del botón "Buscar habitaciones" (columna izquierda).
  // - Si el hotel exige documento (hoy: hotel 27 y hoteles AEBU 30/31) y no
  //   se cargó, bloquea y no avanza.
  // - Si el hotel muestra el campo de rut/documento (showLecturaRut) y se
  //   cargó uno, primero busca los datos del cliente/tarifa preferencial
  //   asociada a ese documento (cada grupo de hoteles contra su propia API).
  // - En cualquier otro caso (o si el rut es opcional y se dejó vacío), dispara la
  //   búsqueda de disponibilidad igual.
  // Solo al llegar al final sin errores pasamos el bloque de habitaciones a resultados.
  const handleBuscarHabitaciones = async () => {
    // ✅ Documento obligatorio: hotel 27 y hoteles de AEBU (30, 31).
    if (HOTELES_DOCUMENTO_OBLIGATORIO.includes(String(hotCod)) && rut.trim() === "") {
      console.log("Documento obligatorio para este hotel");
      setError("El documento del cliente es obligatorio para ver disponibilidad.");
      setRutData(null);
      setRutCliente(null);
      return;
    }

    if (showLecturaRut && rut.trim() !== "") {
      try {
        let response = null;

        if (hotCod === "21") {
          const hotelAdmintour = await obtenerDatosHotel(hotCod);
          response = await datosPax(hotelAdmintour.MotorHotAdmintour, rut);
        } else if (hotCod === "27") {
          console.log("hace la busqueda para el hotel 27");
          const hotelAdmintour = await obtenerDatosHotel(hotCod);
          response = await datosPax(hotelAdmintour.MotorHotAdmintour, rut);
        } else if (HOTELES_AEBU.includes(String(hotCod))) {
          // ✅ Hoteles de AEBU (30, 31): se consulta la API de AEBU por
          // cédula. response queda como { esAfiliado, data } — lo usa
          // RoomTypeRatePlan.js para elegir tipo de cliente "AFILIADO" o
          // tarifa normal.
          console.log("hace la busqueda de afiliado AEBU");
          response = await consultarAfiliadoAebu(rut);
        } else if (["6", "7", "8", "9", "10"].includes(hotCod)) {
          response = await rutLosHeroes(rut);
        }

        setError(null);
        setRutData(response);
        setRutCliente(response);
      } catch (err) {
        console.error("Error al llamar a la API:", err);
        setError("No se pudo obtener la información del cliente.");
        setRutData(null);
        setRutCliente(null);
        return; // no avanzamos a resultados si falló la consulta del documento
      }
    }

    // Dispara/refresca la búsqueda de disponibilidad de habitaciones.
    setSearchTrigger((prev) => !prev);
    setShowRoomResults(true);

    const qs = new URLSearchParams(location.search);
    qs.set("hotcod", hotCod);
    navigate(`${BASE_URL}/disponibilidad/habitaciones?${qs.toString()}`);
  };

  // ✅ Punto de entrada del botón "Buscar actividades" (columna derecha).
  // Es independiente del de habitaciones: no requiere rut/documento ni bloquea si
  // ya se buscaron (o no) habitaciones.
  const handleBuscarActividades = () => {
    if (!activityDate) {
      setActivityError("Seleccioná una fecha para ver las actividades disponibles.");
      return;
    }
    setActivityError(null);
    setShowActivityResults(true);

    const qs = new URLSearchParams(location.search);
    qs.set("hotcod", hotCod);
    navigate(`${BASE_URL}/disponibilidad/actividades?${qs.toString()}`);
  };

  const handleRutChange = (data) => {
    setRutData(data);
    setRutCliente(data);
  };

  const handleSearch = () => {
    setSearchTrigger((prev) => !prev);
  };

  // ✅ NUEVO: punto de entrada de la pantalla de selección inicial ("¿Qué querés
  // reservar?"). Elegir una opción acá es lo que "abre" ese formulario y navega
  // a su pestaña, tal cual funcionaba antes de que el Tab pasara a decidir todo.
  const handleSelectForm = (form) => {
    setActiveForm(form);
    const qs = new URLSearchParams(location.search);
    qs.set("hotcod", hotCod);

    if (form === "actividad" && mostrarActividades) {
      setValue(tabItems.findIndex((t) => t.key === "actividades"));
      navigate(`${BASE_URL}/disponibilidad/actividades?${qs.toString()}`);
    } else {
      setValue(tabItems.findIndex((t) => t.key === "habitaciones"));
      navigate(`${BASE_URL}/disponibilidad/habitaciones?${qs.toString()}`);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    // ✅ Clickear un Tab también cuenta como "elegir" (por si se hace directamente
    // desde el Tab sin pasar por la pantalla de selección inicial).
    const tabSeleccionado = tabItems[newValue];
    const esActividades = tabSeleccionado?.key === "actividades";
    setActiveForm(esActividades ? "actividad" : "habitacion");
    const qs = new URLSearchParams(location.search);
    qs.set("hotcod", hotCod);
    // ✅ El índice del Tab ya NO asume "0 = Habitaciones, 1 = Actividades":
    // ahora depende de tabItems (qué tabs se renderizan para este hotel según
    // MotorHotelTipo), así que navegamos según la key del tab clickeado.
    if (esActividades) {
      navigate(`${BASE_URL}/disponibilidad/actividades?${qs.toString()}`);
    } else {
      navigate(`${BASE_URL}/disponibilidad/habitaciones?${qs.toString()}`);
    }
  };

  // ✅ Contenido de resultados: se arma igual sin importar en qué pestaña estás,
  // mostrando habitaciones si ya se buscaron, actividades si ya se buscaron, o ambas.
  // Esto es lo que garantiza que buscar una no "tape" ni reemplace a la otra: cambiar
  // de pestaña solo cambia qué tan protagonista es cada bloque, no si existe o no.
  // ✅ Ahora cada pestaña muestra SOLO su propio resultado (mode = "habitaciones" |
  // "actividades"). Lo que se buscó en la otra pestaña no se pierde -sigue en
  // showRoomResults/showActivityResults y en el carrito-, solo queda oculto hasta
  // que volvés a esa pestaña. El "Resumen" (carrito), en cambio, sigue mostrando
  // siempre todo lo reservado sin importar la pestaña, para poder vender las dos.
  const renderResultados = (mode) => {
    const showRoom = mode === "habitaciones" && showRoomResults;
    const showActivity = mode === "actividades" && showActivityResults;

    if (!showRoom && !showActivity) return null;

    return (
      <Grid container spacing={2}>
        <Grid item xs={12} md={8}>
          {showRoom && (
            <RoomTypeRatePlan rutData={rutData} searchTrigger={searchTrigger} />
          )}
          {showActivity && (
            <Box>
              <Typography variant="h6" sx={{ mb: 2 }}>
                Actividades disponibles
              </Typography>
              <Activities />
            </Box>
          )}
        </Grid>
        <Grid item xs={12} md={4}>
          <Summary />
        </Grid>
      </Grid>
    );
  };

  return (
    <Box sx={{ mt: 0, px: isMobile ? 2 : 0 }}>
      <Box sx={{ position: "relative", zIndex: 1, mt: 0 }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="Disponibilidad Tabs"
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            width: "100%",
            justifyContent: "flex-start",
            borderBottom: "none",
          }}
        >
          {mostrarHabitaciones && (
            <Tab label="Habitaciones" icon={<BedOutlinedIcon />} iconPosition="start" />
          )}
          {/*<Tab label="Productos" icon={<WineBarIcon />} iconPosition="start" />*/}
          {mostrarActividades && (
            <Tab label="Actividades" icon={<HikingRoundedIcon />} iconPosition="start" />
          )}
        </Tabs>
      </Box>

      <Box
        sx={{
          width: "100vw",
          position: "relative",
          left: "50%",
          right: "50%",
          marginLeft: "-50vw",
          marginRight: "-50vw",
          overflowX: "hidden",
          mt: 2,
        }}
      >
        <Banner />
      </Box>

      {(location.pathname.startsWith(`${BASE_URL}/disponibilidad/habitaciones`) ||
        location.pathname.startsWith(`${BASE_URL}/disponibilidad/actividades`)) && (() => {
        // ✅ El contenido de esta tarjeta ahora depende de en qué PESTAÑA estás
        // (Habitaciones o Actividades), no de un paso previo de "elegí qué querés
        // reservar" — entrar a la pestaña ya dice la intención, así que ese paso
        // sobraba y además hacía que cambiar de pestaña no cambiara nada en pantalla.
        // Cada pestaña sigue recordando su propia búsqueda (no se pierde al cambiar
        // de pestaña) y, una vez buscada una, se ofrece un acceso directo para sumar
        // la otra sin perder lo ya buscado.
        const isActividadesTab =
          mostrarActividades &&
          location.pathname.startsWith(`${BASE_URL}/disponibilidad/actividades`);

        const showResultsForTab = isActividadesTab ? showActivityResults : showRoomResults;
        const otherAlreadySearched = isActividadesTab ? showRoomResults : showActivityResults;
        const otherTabPath = isActividadesTab
          ? buildUrl("/disponibilidad/habitaciones")
          : buildUrl("/disponibilidad/actividades");
        const otherTabLabel = isActividadesTab ? "una habitación" : "una actividad";

        const heroTitle = isActividadesTab ? "Actividades" : "Habitaciones";
        const subtitle = isActividadesTab
          ? "Seleccioná la fecha y la cantidad de adultos y menores."
          : "Seleccioná el período y la cantidad de huéspedes.";

        return (
        <Box
          sx={{
            position: "relative",
            zIndex: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pb: { xs: 4, md: 6 },
          }}
        >
          <Box
            sx={{
              width: "92%",
              maxWidth: "1100px",
              mx: "auto",
              mt: "-60px",
              backgroundColor: "white",
              borderRadius: "20px",
              boxShadow: "0px 12px 40px rgba(0, 0, 0, 0.14)",
              padding: showResultsForTab
                ? { xs: "16px 20px", sm: "20px 32px" }
                : { xs: "28px 20px", sm: "40px 48px" },
            }}
          >
            {activeForm !== null && !showResultsForTab && (
              <Box sx={{ textAlign: "center", mb: { xs: 3, sm: 4 }, position: "relative" }}>
                {/* ✅ Volver a la pantalla de selección sin perder lo que ya se
                    tipeó en el otro formulario (no resetea showRoomResults ni
                    showActivityResults, solo el paso de "qué formulario ver").
                    Solo tiene sentido si el hotel maneja AMBAS (T): si es
                    "H" o "A" no hay "otra opción" a la que volver. */}
                {ambasDisponibles && (
                  <Button
                    variant="text"
                    size="small"
                    onClick={() => setActiveForm(null)}
                    sx={{
                      position: isMobile ? "static" : "absolute",
                      left: 0,
                      top: 0,
                      textTransform: "none",
                      mb: isMobile ? 1 : 0,
                    }}
                  >
                    ‹ Elegir otra opción
                  </Button>
                )}
                <Typography
                  variant="h5"
                  sx={{ fontWeight: 700, color: "primary.dark" }}
                >
                  {heroTitle}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mt: 0.5, maxWidth: 640, mx: "auto" }}
                >
                  {subtitle}
                </Typography>
              </Box>
            )}

            {activeForm === null ? (
              // ===== Selección inicial: elegí qué querés reservar =====
              <Box sx={{ textAlign: "center" }}>
                <Typography
                  variant="h5"
                  sx={{ fontWeight: 700, color: "primary.dark", mb: 0.5 }}
                >
                  ¿Qué quieres reservar?
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: { xs: 3, sm: 4 } }}
                >
                  Elegí una opción para comenzar tu búsqueda.
                </Typography>
                <Grid container spacing={2} justifyContent="center">
                  {mostrarHabitaciones && (
                  <Grid item xs={12} sm={ambasDisponibles ? 6 : 8}>
                    <Box
                      onClick={() => handleSelectForm("habitacion")}
                      sx={{
                        cursor: "pointer",
                        border: "1px solid",
                        borderColor: "divider",
                        borderRadius: "16px",
                        p: 3,
                        height: "100%",
                        transition: "box-shadow .2s ease, border-color .2s ease",
                        "&:hover": {
                          boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.12)",
                          borderColor: "primary.main",
                        },
                      }}
                    >
                      <BedOutlinedIcon sx={{ fontSize: 40, color: "primary.main", mb: 1 }} />
                      <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                        Habitación
                      </Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                        Elegí el período y la cantidad de huéspedes.
                      </Typography>
                    </Box>
                  </Grid>
                  )}

                  {mostrarActividades && (
                    <Grid item xs={12} sm={ambasDisponibles ? 6 : 8}>
                      <Box
                        onClick={() => handleSelectForm("actividad")}
                        sx={{
                          cursor: "pointer",
                          border: "1px solid",
                          borderColor: "divider",
                          borderRadius: "16px",
                          p: 3,
                          height: "100%",
                          transition: "box-shadow .2s ease, border-color .2s ease",
                          "&:hover": {
                            boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.12)",
                            borderColor: "primary.main",
                          },
                        }}
                      >
                        <HikingRoundedIcon sx={{ fontSize: 40, color: "primary.main", mb: 1 }} />
                        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                          Actividad
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                          Elegí la fecha y la cantidad de adultos y menores.
                        </Typography>
                      </Box>
                    </Grid>
                  )}
                </Grid>
              </Box>
            ) : isActividadesTab ? (
              // ===== Actividad =====
              !showActivityResults ? (
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant="subtitle2"
                      sx={{ mb: 1, fontWeight: 600, color: "text.secondary" }}
                    >
                      Fecha
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                      <ActivityDatePickerComponent
                        value={activityDate ? dayjs(activityDate) : null}
                        onChange={(newDate) => {
                          if (!newDate || !newDate.isValid()) {
                            setActivityDate("");
                            return;
                          }
                          setActivityDate(newDate.format("YYYY-MM-DD"));
                          if (activityError) setActivityError(null);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            error={!!activityError}
                            helperText={activityError || " "}
                          />
                        )}
                        inputFormat="DD/MM/YYYY"
                        minDate={dayjs()}
                        sx={{ width: "100%" }}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={6} sm={3}>
                    <Typography
                      variant="subtitle2"
                      sx={{ mb: 1, fontWeight: 600, color: "text.secondary" }}
                    >
                      Adultos
                    </Typography>
                    <TextField
                      fullWidth
                      type="number"
                      inputProps={{ min: 0 }}
                      value={activityAdults}
                      onChange={(e) =>
                        setActivityAdults(Math.max(0, Number(e.target.value) || 0))
                      }
                    />
                  </Grid>
                  <Grid item xs={6} sm={3}>
                    <Typography
                      variant="subtitle2"
                      sx={{ mb: 1, fontWeight: 600, color: "text.secondary" }}
                    >
                      Menores
                    </Typography>
                    <TextField
                      fullWidth
                      type="number"
                      inputProps={{ min: 0 }}
                      value={activityChildren}
                      onChange={(e) =>
                        setActivityChildren(Math.max(0, Number(e.target.value) || 0))
                      }
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      onClick={handleBuscarActividades}
                      size="large"
                      sx={{ height: 56, borderRadius: "10px", fontWeight: 700 }}
                    >
                      Buscar actividades
                    </Button>
                  </Grid>
                </Grid>
              ) : (
                <>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                    <HikingRoundedIcon color="primary" />
                    <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                      Actividad
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      backgroundColor: "#f7f9fa",
                      borderRadius: "12px",
                      padding: "8px 16px",
                      display: "flex",
                      flexDirection: isMobile ? "column" : "row",
                      alignItems: isMobile ? "flex-start" : "center",
                      justifyContent: "space-between",
                      gap: 1.5,
                    }}
                  >
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                      {formatActivityDate()} · {activitySummaryLabel}
                    </Typography>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() => setShowActivityResults(false)}
                      sx={{ whiteSpace: "nowrap" }}
                    >
                      Modificar
                    </Button>
                  </Box>
                </>
              )
            ) : (
              // ===== Habitación =====
              !showRoomResults ? (
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography
                      variant="subtitle2"
                      sx={{ mb: 1, fontWeight: 600, color: "text.secondary" }}
                    >
                      Período
                    </Typography>
                    <Calendar2 />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      variant="subtitle2"
                      sx={{ mb: 1, fontWeight: 600, color: "text.secondary" }}
                    >
                      Huéspedes
                    </Typography>
                    {/* Guests.css trae ".guests .MuiButton-root { margin: 0.5em 0 }",
                        que empuja el botón y lo desalinea contra los TextField de al
                        lado. Con la misma especificidad de selector, forzamos altura
                        fija y anulamos ese margen con !important. */}
                    <Box
                      sx={{
                        "& .MuiButton-root": {
                          height: "56px !important",
                          margin: "0 !important",
                        },
                      }}
                    >
                      <Guests />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sx={{ mb: showLecturaRut ? 0 : 3 }}>
                    <Typography
                      variant="subtitle2"
                      sx={{ mb: 1, fontWeight: 600, color: "text.secondary" }}
                    >
                      {showLecturaRut ? "Rut / Documento" : "Código promocional"}
                    </Typography>
                    {showLecturaRut ? (
                      <TextField
                        fullWidth
                        value={rut}
                        onChange={(e) => {
                          setRut(e.target.value);
                          if (error) setError(null);
                        }}
                        placeholder={
                          HOTELES_DOCUMENTO_OBLIGATORIO.includes(String(hotCod))
                            ? "Documento cliente"
                            : "Rut Afiliado"
                        }
                        variant="outlined"
                        error={!!error}
                        helperText={
                          error
                            ? error
                            : HOTELES_DOCUMENTO_OBLIGATORIO.includes(String(hotCod))
                              ? "Doc. 12345678"
                              : "Ej de RUT. 1234567-8"
                        }
                      />
                    ) : (
                      // ✅ PromotionalCode parece dibujar su contenido más alto de lo que
                      // reserva su propia caja (por eso pisaba el botón de abajo). Como no
                      // tengo ese componente, le agrego un margen inferior extra al Grid
                      // item que lo contiene para garantizar aire hasta "Buscar habitaciones".
                      <PromotionalCode />
                    )}
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      onClick={handleBuscarHabitaciones}
                      size="large"
                      sx={{ height: 56, borderRadius: "10px", fontWeight: 700 }}
                    >
                      Buscar habitaciones
                    </Button>
                  </Grid>
                </Grid>
              ) : (
                <>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                    <BedOutlinedIcon color="primary" />
                    <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                      Habitación
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      backgroundColor: "#f7f9fa",
                      borderRadius: "12px",
                      padding: "8px 16px",
                      display: "flex",
                      flexDirection: isMobile ? "column" : "row",
                      alignItems: isMobile ? "flex-start" : "center",
                      justifyContent: "space-between",
                      gap: 1.5,
                    }}
                  >
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                      {formatSelectedRange()} · {guestSummaryLabel}
                    </Typography>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() => setShowRoomResults(false)}
                      sx={{ whiteSpace: "nowrap" }}
                    >
                      Modificar
                    </Button>
                  </Box>
                </>
              )
            )}

            {/* ✅ Cross-sell: una vez que ya buscaste una de las dos y todavía no
                buscaste la otra, ofrecemos ir directo a la otra pestaña a sumarla,
                sin perder lo que ya buscaste acá. */}
            {ambasDisponibles && showResultsForTab && !otherAlreadySearched && (
              <Box sx={{ mt: 2, textAlign: isMobile ? "left" : "center" }}>
                <Button
                  variant="text"
                  onClick={() => navigate(otherTabPath)}
                  sx={{ textTransform: "none" }}
                >
                  + Sumar {otherTabLabel}
                </Button>
              </Box>
            )}
          </Box>
        </Box>
        );
      })()}

      <Grid
        container
        spacing={2}
        // ✅ El margen solo aplica si la pestaña ACTIVA tiene su propio resultado
        // para mostrar (antes era con cualquiera de los dos, aunque el otro tab
        // estuviera vacío y no renderizara nada debajo). Ya no asumimos que
        // "value === 1" es Actividades: depende de tabItems.
        mt={
          (tabItems[value]?.key === "actividades" ? showActivityResults : showRoomResults)
            ? 1
            : 0
        }
        sx={{ px: isMobile ? 2 : 0 }}
      >
        <Routes>
          <Route
            path="/"
            element={
              <Navigate
                to={buildUrl(
                  mostrarHabitaciones
                    ? "/disponibilidad/habitaciones"
                    : "/disponibilidad/actividades"
                )}
                replace
              />
            }
          />
          {mostrarHabitaciones && (
            <Route path="/habitaciones" element={renderResultados("habitaciones")} />
          )}
          {/*<Route path="/productos" element={
            <Grid container spacing={2}>
              <Grid item xs={12} md={8}>
                <Products />e
              </Grid>
              <Grid item xs={12} md={4}>
                <Summary />
              </Grid>
            </Grid>
          } />*/}
          {mostrarActividades && (
            <Route path="/actividades" element={renderResultados("actividades")} />
          )}
        </Routes>
      </Grid>

      {/* ✅ OVERLAY encima del motor (se muestra cuando viene showRedirectOverlay=1) */}
      <Backdrop
        open={redirectOverlayOpen}
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 10 }}
      >
        <Fade in={redirectOverlayOpen}>
          <Card sx={{ width: "95%", maxWidth: 760, borderRadius: 3 }}>
            <CardContent sx={{ p: { xs: 3, md: 4 } }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <CircularProgress size={26} />
                <Typography variant="h6">
                  Se lo está redirigiendo al motor de reservas
                  {redirectOverlayHotelName ? ` del hotel "${redirectOverlayHotelName}"` : ""}.
                </Typography>
              </Box>

              <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                Realice su búsqueda para las fechas que desea visitar.
              </Typography>

              <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end", gap: 1 }}>
                <Button
                  variant="contained"
                  onClick={() => setRedirectOverlayOpen(false)}
                  sx={{ borderRadius: 999 }}
                >
                  Entendido
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Fade>
      </Backdrop>

      <Dialog open={openDocDialog27} onClose={() => setOpenDocDialog27(false)}>
        <DialogTitle>Documento requerido</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mt: 1 }}>
            Para obtener tu <b>tarifa preferencial</b>, en caso de ser socio,
            seleccioná el período de alojamiento, ingresá tu documento completo y
            hacé clic en <b>Buscar</b>.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDocDialog27(false)} variant="contained">
            Entendido
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default MainComponent;